import classes from "./CaseStudiesItems.module.scss";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { fetchCaseStudies } from "../../../data/caseStudies";
import { CaseStudiesItemsDesktop } from "./CaseStudiesItemsDesktop";
import { CaseStudiesItemsMobile } from "./CaseStudiesItemsMobile";

export const CaseStudiesItems = () => {
  const { locale } = useRouter();
  const { data } = useQuery(
    [
      "case-studies",
      {
        locale: locale!,
      },
    ],
    fetchCaseStudies,
    {
      enabled: !!locale,
    }
  );

  if (data == null) {
    return null;
  }

  return (
    <div>
      <div className={classes.desktopContainer}>
        <CaseStudiesItemsDesktop data={data} />
      </div>
      <div className={classes.mobileContainer}>
        <CaseStudiesItemsMobile data={data} />
      </div>
    </div>
  );
};
